import EditPopover from './EditPopover'
import EditTextFields from './EditTextField'
import EditFieldHeader from './EditFieldHeader'
import EditButtons from './EditButtons'
EditPopover.TextField = EditTextFields
EditPopover.HeaderField = EditFieldHeader
EditPopover.Buttons = EditButtons

export default EditPopover
